import { render, staticRenderFns } from "./HistoricPasses.vue?vue&type=template&id=2018e85a&scoped=true"
import script from "./HistoricPasses.vue?vue&type=script&lang=js"
export * from "./HistoricPasses.vue?vue&type=script&lang=js"
import style0 from "./HistoricPasses.vue?vue&type=style&index=0&id=2018e85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018e85a",
  null
  
)

export default component.exports